import React, { useRef } from "react";
import styled from "styled-components";
import { Swiper, SwiperSlide } from "swiper/react";
import CardGameStartPop from "@components/cardgame/CardGameStartPop";
import TrainGameStartPop from "@components/traingame/GameStartPop";
import DonutGameStartPop from "@components/donutgame/GameStartPop";
import playSound from "@/sound";
import { useEffect } from "react";

const Wrap = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;

  .swiper {
    border-radius: 0 !important;
    .swiper-slide {
      transition: opacity 0.4s;
      opacity: 0.3;
      &.swiper-slide-active {
        opacity: 1;
      }
    }
  }
`;

const GuideContainer = styled.div`
  position: relative;
  width: 100%;
  height: 810px;
  transform: translateX(-50%);
  left: 50%;
`;

const GameGuideText = styled.div`
  position: absolute;
  left: 50%;
  width: 769px;
  height: 103px;
  transform: translateX(-50%);
  bottom: -150px;
  background: url(${require("@assets/img/game_guide_text.png")}) no-repeat;
  display: inline-block;
`;

// const DirectionButton = styled.button`
//   position: absolute;
//   width: 186px;
//   top: 50%;
//   margin-top: -75px;
//   height: 158px;
//   z-index: 5;
//   &.next {
//     background: url(${require("@assets/img/word_pop_next.png")});
//     right: -1px;
//   }

//   &.prev {
//     background: url(${require("@assets/img/word_pop_prev.png")});
//     left: -1px;
//   }

//   &.swiper-button-disabled {
//     opacity: 0.2;
//   }
//   transition: opacity 0.4s;
// `;
const GameGuide = ({ onStart }) => {
  const swiperRef = useRef(null);

  const onSlideChange = (e) => {
    playSound.wordStop();
    if (e.activeIndex === 0) {
      playSound.word(
        require("@data/assets/_static/sounds/traingame_start.mp3")
      );
    } else if (e.activeIndex === 1) {
      playSound.word(
        require("@data/assets/_static/sounds/donutgame_start.mp3")
      );
    } else if (e.activeIndex === 2) {
      playSound.word(require("@data/assets/_static/sounds/cardgame_start.mp3"));
    } else {
    }
  };

  useEffect(() => {
    document.body.classList.add("has-popup");
    playSound.word(require("@data/assets/_static/sounds/traingame_start.mp3"));

    if (window.__currentGameType === "card") {
      swiperRef.current.slideTo(2, 0);
    } else if (window.__currentGameType === "donut") {
      swiperRef.current.slideTo(1, 0);
    } else if (window.__currentGameType === "train") {
      swiperRef.current.slideTo(0, 0);
    }

    return () => {
      document.body.classList.remove("has-popup");
      playSound.wordStop();
    };
  }, []);

  return (
    <Wrap>
      <GuideContainer>
        <Swiper
          onSwiper={(swiper) => (swiperRef.current = swiper)}
          spaceBetween={0}
          slidesPerView={1.49}
          centeredSlides={true}
          onSlideChange={onSlideChange}
        >
          <SwiperSlide className="a">
            <TrainGameStartPop onClick={() => onStart("train")} />
          </SwiperSlide>
          <SwiperSlide className="a">
            <DonutGameStartPop onClick={() => onStart("donut")} />
          </SwiperSlide>
          <SwiperSlide className="a">
            <CardGameStartPop onClick={() => onStart("card")} />
          </SwiperSlide>
        </Swiper>

        <GameGuideText />
      </GuideContainer>
    </Wrap>
  );
};

export default GameGuide;
